import React, { useEffect, useState } from "react";
import {
  AuBankIcon,
  AuBankSmallIcon,
  BusinessInformationIcon,
  BusinessInformationRedIcon,
  BusinessSecurityIcon,
  BusinessSecurityRedIcon,
  CheckCircleGreen,
  CreateAccountIcon,
  ProjExelLogo,
} from "../../assets/images";
import PlanCard from "./PlanCard";
import { returnInputFieldLength } from "../../utils/commonFunctions";
import { AccountPaymentVerificationResponseType } from "../../redux/auth/authTypes";
const steps = [
  {
    icon: CreateAccountIcon,
    redIcon: CreateAccountIcon,
  },
  {
    icon: AuBankSmallIcon,
    redIcon: AuBankSmallIcon,
  },
  {
    icon: BusinessSecurityIcon,
    redIcon: BusinessSecurityRedIcon,
  },
];
type AppProps = {
  // onNext: (data: any) => void;
  // activeStep: number;
  // onPayment: () => void;
  // voucherCode: string;
  // planSelected: string;
  // message: string | null;
  // isVoucherCodeVerified: boolean;
  // setPlanSelected: React.Dispatch<React.SetStateAction<string>>;
  // setVoucherCode: (data: string) => void;
  // handleVerifyAccountNumber: (data: string) => void;
  // handleVerifyVocuher: (data: string) => void;
  // auAccountNumberVerifyData: any;
  // handleToggleSubcriptionPlan: () => void;
  // verifyVoucherMessage: string | null;
  // isAuAccountNumberVerified: boolean;
  // dispatchIsAccountNumberVerified: () => void;
  // accountPaymentVoucherVerification
  onNext: (data: any) => void;
  activeStep: number;
  onPayment: (e: any) => void;
  voucherCode: string;
  planSelected: string;
  message: string | null;
  isVoucherCodeVerified: boolean;
  setPlanSelected: React.Dispatch<React.SetStateAction<string>>;
  setVoucherCode: (data: string) => void;
  handleVerifyAccountNumber: (data: string) => void;
  handleVerifyVocuher: (data: string) => void;
  auAccountNumberVerifyData: any;
  handleToggleSubcriptionPlan: () => void;
  verifyVoucherMessage: string | null;
  isAuAccountNumberVerified: boolean;
  accountPaymentVoucherVerification: AccountPaymentVerificationResponseType,
  dispatchIsAccountNumberVerified: () => void;
  setIsPaymentSuccessfull: React.Dispatch<React.SetStateAction<boolean>>;
  setOrderId: React.Dispatch<React.SetStateAction<string>>;
  isPaymentSuccessfull: boolean
  dispatchResetIsVoucherCodeVerified: () => void;
};
const AuAccountVerification = ({
  onNext,
  message,
  setOrderId,
  activeStep,
  isVoucherCodeVerified,
  handleVerifyAccountNumber,
  auAccountNumberVerifyData,
  handleVerifyVocuher,
  voucherCode,
  onPayment,
  planSelected,
  setIsPaymentSuccessfull,
  isPaymentSuccessfull,
  setPlanSelected,
  setVoucherCode,
  handleToggleSubcriptionPlan,
  verifyVoucherMessage,
  isAuAccountNumberVerified,
  dispatchIsAccountNumberVerified,
  accountPaymentVoucherVerification,
  dispatchResetIsVoucherCodeVerified
}: AppProps) => {
  const [accountNumber, setAccounNumber] = useState("");
  const [statusVerificationDetails, setStatusVerificationDetails] = useState<AccountPaymentVerificationResponseType>({} as AccountPaymentVerificationResponseType)

  const isBankAccountVerified =
    isAuAccountNumberVerified ||
    statusVerificationDetails?.bank_account_verification_detials?.is_bank_account_verified === 1;

  const isVoucherVerified =
    isVoucherCodeVerified ||
    statusVerificationDetails?.voucher_code_verification_details?.is_verified === 1;


  useEffect(() => {
    // dispatchIsAccountNumberVerified();
    let persistedData: any = localStorage.getItem("accountInfo");
    if (persistedData) {
      let parsedData = JSON.parse(persistedData);
      setAccounNumber(parsedData?.accountNumber || "");
      setVoucherCode(parsedData?.voucherCode || "");
      setPlanSelected(parsedData?.selectedPlan || "");
    }
  }, []);


  useEffect(() => {
    setStatusVerificationDetails({ ...accountPaymentVoucherVerification })
    if (accountPaymentVoucherVerification?.bank_account_verification_detials?.bank_account_number) {
      setAccounNumber(accountPaymentVoucherVerification?.bank_account_verification_detials?.bank_account_number)
    }
    if (accountPaymentVoucherVerification?.voucher_code_verification_details?.voucher_code) {
      setVoucherCode(accountPaymentVoucherVerification?.voucher_code_verification_details?.voucher_code)
    }
    if (accountPaymentVoucherVerification?.payment_status?.is_payment_verified) {
      setOrderId(accountPaymentVoucherVerification?.payment_status?.payment_gateway_order_id)

      setPlanSelected("Advanced Plan")
      setIsPaymentSuccessfull(true)

    } else {
      setPlanSelected("Basic Plan")
    }
  }, [accountPaymentVoucherVerification])

  const handleNext = (e: any, type: string) => {
    e.preventDefault();
    const data = {
      accountNumber,
      voucherCode,
      selectedPlan: planSelected,
      isAuAccountNumberVerified: accountPaymentVoucherVerification?.bank_account_verification_detials?.is_bank_account_verified ? !!accountPaymentVoucherVerification?.bank_account_verification_detials?.is_bank_account_verified : isAuAccountNumberVerified,
      auAccountNumberVerifyData: accountPaymentVoucherVerification?.bank_account_verification_detials?.bank_account_verification_details ? JSON.parse(accountPaymentVoucherVerification?.bank_account_verification_detials?.bank_account_verification_details)?.data : auAccountNumberVerifyData,
      isVoucherCodeVerified: accountPaymentVoucherVerification?.voucher_code_verification_details?.is_verified ? !!accountPaymentVoucherVerification?.voucher_code_verification_details?.is_verified : isVoucherCodeVerified,
    };
    localStorage.setItem("accountInfo", JSON.stringify(data));
    if (type === "next") {

      onNext(data);
    }
  };


  const handlePlanSelect = (planTitle: string) => {
    setPlanSelected(planTitle);

  };

  const handleVerifyAccount = () => {
    handleVerifyAccountNumber(accountNumber);
  };
  const handleVerifyVoucherCode = () => {
    handleVerifyVocuher(voucherCode);
  };
  const isVerificationPending =
    !isAuAccountNumberVerified || !isVoucherCodeVerified;

  const handleVouchercode = (e: any) => {
    dispatchResetIsVoucherCodeVerified();
    setVoucherCode(e.target.value.toUpperCase());

  };

  const handleAccountNumberChange = (e: any) => {
    dispatchIsAccountNumberVerified();
    setAccounNumber(e.target.value);
  };
  return (
    <>
      <div className="main-signup">
        <div className="au-account-verification-info-container">
          <div className="logo-section mb-3">
            <div className="d-flex">
              <img src={ProjExelLogo} className="company-logo" />
              <img
                src={AuBankIcon}
                className="company-logo"
                style={{ height: "50px", marginLeft: "27px" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                marginBottom: "30px",
                width: "258px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {steps?.map((step, index) => (
                <>
                  <div key={index} className="step-indicator">
                    <span
                      className={`step${activeStep === index ? "active" : ""}`}
                    >
                      <img
                        src={
                          activeStep === index || activeStep > index
                            ? step?.redIcon
                            : step?.icon
                        }
                        alt={" Icon"}
                      />
                    </span>
                    <span className="line"></span>
                  </div>
                </>
              ))}
            </div>
          </div>

          <h5 className="mt-4 right-panel-heading">
            Account Verification & Plan Selection
          </h5>
          <span className="right-panel-subHeading">
            Confirm Your AU Account.
          </span>
          <form>
            <div className="form-group mt-3">
              <div className="">
                <div className="account-verification-heading">
                  <div className="account-number">
                    <div style={{ flex: 1 }}>
                      <label htmlFor="foldername">
                        Account Number Verification
                        <span className="color-red">*</span>
                      </label>
                      <input
                        type={"text"}
                        className={"form-control mb-3"}
                        name="text"
                        value={accountNumber}
                        autoFocus
                        onChange={(e) => handleAccountNumberChange(e)}
                        maxLength={60}
                        disabled={statusVerificationDetails?.bank_account_verification_detials?.is_bank_account_verified === 1}
                      />
                    </div>
                  </div>

                  {isAuAccountNumberVerified || statusVerificationDetails?.bank_account_verification_detials?.is_bank_account_verified === 1 ? (
                    <div className="verified-container">
                      <span>
                        <img src={CheckCircleGreen} alt="Verified" />
                      </span>
                      <span className="verified-text">Verified</span>
                    </div>
                  ) : (
                    <span
                      // className="verify-text" 
                      // onClick={handleVerifyAccount}
                      className={`verify-text ${!accountNumber?.trim()?.length ? "disabled-verify-light" : ""}`}
                      style={{
                        cursor: accountNumber?.trim()?.length ? "pointer" : "not-allowed",
                      }}
                      onClick={accountNumber?.trim()?.length ? handleVerifyAccount : undefined}
                    >
                      Verify
                    </span>
                  )}
                </div>
                <div className="apply-voucher-parent-container">
                  <div className="apply-voucher-line"></div>
                  <span className="apply-voucher-text">
                    Apply Voucher & Choose Plan
                  </span>
                  <div className="apply-voucher-line"></div>
                </div>
                <div className="account-verification-heading">
                  <div className="account-number">
                    <div style={{ flex: 1 }}>
                      <label htmlFor="foldername">
                        Apply Voucher Code <span className="color-red">*</span>
                      </label>
                      <input
                        type={"text"}
                        className={"form-control mb-3"}
                        name="text"
                        value={voucherCode}
                        onChange={(e) => handleVouchercode(e)}
                        disabled={!isBankAccountVerified || statusVerificationDetails?.voucher_code_verification_details?.is_verified === 1}
                      />
                    </div>
                  </div>


                  {isVoucherVerified ? (
                    <div className="verified-container">
                      <span>
                        <img src={CheckCircleGreen} alt="Verified" />
                      </span>
                      <span className="verified-text">Verified</span>
                    </div>
                  ) : (
                    <span
                      className={`verify-text ${!isBankAccountVerified || voucherCode?.trim()?.length === 0 ? "disabled-verify-light" : ""}`}
                      style={{
                        cursor: isBankAccountVerified ? "pointer" : "not-allowed",
                      }}
                      onClick={isBankAccountVerified ? handleVerifyVoucherCode : undefined}
                    >
                      Verify
                    </span>
                  )}
                </div>



                <div className="mt-2">
                  <label htmlFor="choosePlan">
                    Choose Plan <span className="color-red">*</span>
                  </label>
                  <div className="plan-selection-container mt-2">
                    <PlanCard
                      title="Basic Plan"
                      features={[
                        "Includes essential features to manage sales, purchases, and basic accounting.",
                      ]}
                      originalPrice="17,999"
                      discountedPrice="0"
                      isAUCustomer={true}
                      onSelect={() => !!statusVerificationDetails?.payment_status?.is_payment_verified ? null : handlePlanSelect("Basic Plan")}
                      isSelected={planSelected === "Basic Plan"}
                    />
                    <PlanCard
                      title="Advanced Plan"
                      features={[
                        "Unlock advanced features like multi-currency support, AI-powered invoicing, custom reports, and more.",
                      ]}
                      originalPrice="37,999"
                      discountedPrice="9,999"
                      isAUCustomer={true}
                      onSelect={() => !!statusVerificationDetails?.payment_status?.is_payment_verified ? null : handlePlanSelect("Advanced Plan")}
                      isSelected={planSelected === "Advanced Plan" || !!statusVerificationDetails?.payment_status?.is_payment_verified}
                    />
                  </div>
                </div>

                <p
                  className={`show-subscription-details-text`}
                  onClick={handleToggleSubcriptionPlan}
                >
                  *Click here to know detailed plans
                </p>
                <div
                  className="mb-3 mt-3 d-flex"
                  style={{ float: "inline-end" }}
                >
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ width: "94px" }}
                    disabled={

                      statusVerificationDetails?.payment_status?.is_payment_verified ? false : (!isBankAccountVerified || !isVoucherVerified)

                    }
                    onClick={(e) => {
                      if (planSelected === "Advanced Plan" && !statusVerificationDetails?.payment_status?.is_payment_verified) {
                        handleNext(e, "")
                        onPayment(e)
                      } else {
                        handleNext(e, "next")
                      }
                    }}
                  >
                    {(planSelected === "Advanced Plan" && !statusVerificationDetails?.payment_status?.is_payment_verified) ? "Pay Now" : "Next"
                    }
                  </button>
                </div>
              </div>
            </div>
          </form>
          <p className="mobileCopyright">
            &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
          </p>
        </div >
      </div >
    </>
  );
};

export default AuAccountVerification;
